// carousel wrapper 

export const carouselWrapperTemplate = (carouselOptionalClasses, carouselId, carouselUrl, carouselTitle) =>`
<div class="${carouselOptionalClasses}" id="${carouselId}">
    <h2 class="carousel-title"><a href="${carouselUrl}"><svg class="icon slant"><use xlink:href="#icon-slant"></use></svg>${carouselTitle}</a></h2>
    <div class="carousel-wrapper">
        <div class="view-back hidden-mb endposition">
            <svg class="icon arrow-left"><use xlink:href="#icon-arrow_right"></use></svg>
        </div>
        <div class="view-next hidden-mb">
            <svg class="icon arrow-right"><use xlink:href="#icon-arrow_right"></use></svg>
        </div>
        <div class="carousel-content">        
        </div>
    </div>
</div>
`